import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { Store, StoreListParams } from '~/features/store/types/store.type';

/**
 * 매장 목록 조회
 * @description ADMIN, STORE_MANAGER 권한 필요
 * @endpoint GET /admin/stores
 * @param params - 조회 파라미터
 * @returns 매장 목록
 */
export function getStoreListApi(params?: StoreListParams) {
  return axiosInstance.get<PaginatedApiResponse<Store>>('/admin/stores', { params });
}
